import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../../store/userStore';
import { USER_addres } from '../../API/API';

/**
 * Страница на которую Google редиректит после авторизации.
 * URL: /auth/google/callback?code=...&state=...
 *
 * Только login-mode.
 */
const TOKEN_KEY = 'Authorization';

const GoogleCallback = () => {
    const navigate = useNavigate();
    const refresh = useUserStore(s => s.refresh);
    const [error, setError] = useState('');
    const [step, setStep] = useState('Подключаемся к Google...');
    const exchangedRef = useRef(false);

    useEffect(() => {
        if (exchangedRef.current) return;
        exchangedRef.current = true;

        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const googleError = params.get('error');

        if (googleError) {
            setError('Google отменил вход: ' + googleError);
            return;
        }
        if (!code || !state) {
            setError('Неполные данные от Google');
            return;
        }

        (async () => {
            try {
                setStep('Получаем ваш профиль...');
                const r = await fetch(`${USER_addres}/api/v1/users/auth/google/exchange`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ code, state }),
                });
                const data = await r.json();
                if (!r.ok || !data.token) {
                    setError(data.message || 'Не удалось завершить вход');
                    return;
                }
                localStorage.setItem(TOKEN_KEY, data.token);
                if (data.refreshToken) {
                    localStorage.setItem('refreshToken', data.refreshToken);
                }
                setStep('Заходим в кабинет...');
                // Жёсткий редирект — SPA подхватит токен из localStorage при init.
                setTimeout(() => { window.location.replace('/cabinet'); }, 200);
            } catch (e) {
                setError('Сеть недоступна, попробуйте ещё раз');
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <main style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 20,
        }}>
            <div style={{
                maxWidth: 420,
                width: '100%',
                background: '#fff',
                border: '1px solid #e6e7eb',
                borderRadius: 16,
                padding: 32,
                textAlign: 'center',
                boxShadow: '0 4px 16px rgba(0,0,0,0.05)',
            }}>
                {error ? (
                    <>
                        <div style={{
                            width: 64, height: 64,
                            borderRadius: '50%',
                            background: '#fee2e2',
                            color: '#dc2626',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            margin: '0 auto 16px',
                            fontSize: 32, fontWeight: 700,
                        }}>!</div>
                        <h2 style={{ fontSize: 20, marginBottom: 12, color: '#0f172a' }}>Не удалось войти</h2>
                        <p style={{ color: '#64748b', marginBottom: 20 }}>{error}</p>
                        <button
                            onClick={() => navigate('/login')}
                            style={{
                                padding: '10px 20px',
                                background: '#3b82f6',
                                color: '#fff',
                                border: 'none',
                                borderRadius: 8,
                                cursor: 'pointer',
                                fontSize: 14,
                                fontWeight: 600,
                            }}
                        >Вернуться ко входу</button>
                    </>
                ) : (
                    <>
                        <div style={{
                            width: 48, height: 48,
                            border: '4px solid #e6e7eb',
                            borderTopColor: '#4285F4',
                            borderRadius: '50%',
                            margin: '0 auto 16px',
                            animation: 'spin 1s linear infinite',
                        }} />
                        <h2 style={{ fontSize: 18, marginBottom: 8, color: '#0f172a' }}>Вход через Google</h2>
                        <p style={{ color: '#64748b' }}>{step}</p>
                        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                    </>
                )}
            </div>
        </main>
    );
};

export default GoogleCallback;
